import { Artist } from 'models/Artist';
import React, { JSX, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApiService } from 'services/ApiService';
import ArtistNavigationBar from './ArtistNavigationBar';
import ArtistHeroSection from './ArtistHeroSection';
import ArtistPortfolio from './ArtistPortfolio';
import ArtistTattooStyles from './ArtistTattooStyles';
import ArtistFollowButton from './ArtistFollowButton';

const ArtistLanding: React.FC = () => {

    const { artistId = "" } = useParams<{ artistId?: string }>();
    const [artist, setArtist] = useState<Artist | null>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [selectedSection, setSelectedSection] = useState<string>("Home");
    const [isVisitor, setIsVisitor] = useState<boolean>(true);

    useEffect(() => {
        const fetchArtist = async () => {
            try {
                const response = await ApiService.getArtistInfo(artistId ?? "");
                if (response.success && response.data) {
                    setArtist(response.data);
                }
            } catch (error) {
                console.error("Error fetching artist:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchArtist();
    }, [artistId]
    );

    // Lazy load components only once
    useEffect(() => {
        if (!sectionsLoaded[selectedSection]) {
            setSectionsLoaded((prev) => ({ ...prev, [selectedSection]: true }));
        }
    }, [selectedSection]);

    useEffect(() => {
        const userId = localStorage.getItem("userId");
        console.log("userId in ArtistLanding: " + userId);
        if (userId && userId == artistId) {
            setIsVisitor(() => false);
        }
        if (userId && artistId && userId === artistId) {
            setIsVisitor(() => false);
        }
    }, [artistId]);

    const [sectionsLoaded, setSectionsLoaded] = useState<Record<string, boolean>>({
        Home: false,
        "Flash Store": false,
        Portfolio: false,
        Styles: false,
        About: false,
        Reviews: false,
        Tours: false
    });
    // Preload components into state so they persist
    const sectionComponents: Record<string, JSX.Element> = {
        Home: <ArtistHeroSection artistId={artistId ?? ""} isVisitor={isVisitor} />,
        //"Flash Store": <FlashStoreComponent />,
        Portfolio: <ArtistPortfolio artistId={artistId ?? ""} isVisitor={isVisitor} />,
        Styles: <ArtistTattooStyles artistId={artistId ?? ""} isVisitor={isVisitor} />,
        //About: <AboutComponent />,
        //Reviews: <ReviewsComponent />
        //Tours: <ArtistLocations artistId={artistId ?? ""} isVisitor={isVisitor} />,
        };


    if (!artistId) return <p>Loading artist information...</p>;
    if (isLoading) return <p>Loading...</p>;
    if (!artist) return <h1>No artist data available</h1>;

    const handleSectionClick = (section: string) => {
        setSelectedSection(section);
    }

    // Render all sections but only show the active one
    return (
        <div>
            <div className="flex items-center justify-between gap-4 px-4 py-3">
                <h1 className="text-2xl font-bold text-gray-900">
                    {artist.firstName} {artist.lastName}'s Page
                </h1>
                <ArtistFollowButton artistId={artistId ?? artist.id} isVisitor={isVisitor} />
            </div>
            <div>
                <ArtistNavigationBar onSelect={handleSectionClick} />
            </div>
            {Object.keys(sectionComponents).map((key, index) => (
                <div key={index} style={{ display: selectedSection === key ? "block" : "none" }}>
                    {sectionsLoaded[key] ? sectionComponents[key] : null}
                </div>
            ))}
        </div>
    )
}

export default ArtistLanding;